//#region src/assets/scan-credit-card.svg
var scan_credit_card_default = "" + new URL("scan-credit-card-cXIHnzed.svg", import.meta.url).href;
//#endregion
export { scan_credit_card_default as default };

//# sourceMappingURL=scan-credit-card.js.map